import Button from "components/Button";
import { useGoBackOrHome } from "../../hooks";

import ChevronLeftIcon from "resources/icons/chevron-left.svg";

interface BackButtonProps {
  className?: string;
}

const BackButton = ({ className }: BackButtonProps) => {
  const goBackOrHome = useGoBackOrHome();

  return (
    <Button
      variant="tertiary"
      icon={<ChevronLeftIcon />}
      className={className}
      onClick={goBackOrHome}
    />
  );
};

export default BackButton;
